import { ChannelValue } from 'common/RecipientBadge/types'
import { MinimalChannel, SettingsMember, RecipientsSelectorValueType } from 'types'
import { UserValue } from 'components/ShareSheet/RecipientSelector/Types'

export const toUserValue = (member: SettingsMember): UserValue => ({
  value: member,
  type: RecipientsSelectorValueType.User,
})

export const toChannelValue = (member: MinimalChannel): ChannelValue => ({
  type: RecipientsSelectorValueType.Channel,
  value: member,
})
